import { Link } from "react-router-dom";
import logo from "../../assets/img/logo.png";

const AuthShell = ({ children, eyebrow, title, subtitle, footer, size = "md" }) => {
  return (
    <main className="auth-screen">
      <section className={`auth-panel auth-panel-${size}`}>
        <header className="auth-topbar">
          <Link className="auth-brand-logo" to="/login">
            <img src={logo} alt="Facturize" />
          </Link>

          <div className="auth-brand-copy">
            <span className="auth-eyebrow">{eyebrow}</span>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </header>

        <section className="auth-main">
          <div className="auth-card">
            {children}
          </div>
          {footer && <div className="auth-footer">{footer}</div>}
        </section>
      </section>
    </main>
  );
};

export default AuthShell;
